import React from "react";
import "./LoadingPage.scss";

function LoadingPage() {
  return (
    <div className="loading-backdrop">
      <span className="loader"></span>
    </div>
  );
}

export default LoadingPage;
